/// <amd-module name="Feed/Core/Redux/PerfTracker/PerfTrackerSaga" />
import { PerfScenarios } from "Feed/Common/Constants/Constants";
import { PerfTrackerActionTypes } from "Feed/Core/Redux/PerfTracker/PerfTrackerActions";
import { SagaIterator } from "redux-saga";
import { effects } from "redux/redux-saga.compat";
import { ActionWithPayload } from "redux/Utils/ActionHelper";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";

export default function* rootSaga(): SagaIterator {
    yield effects.takeEvery(PerfTrackerActionTypes.StartPerformanceTracking, startTracking);
    yield effects.takeEvery(PerfTrackerActionTypes.EndPerformanceTracking, endTracking);
}
function* startTracking(
    action: ActionWithPayload<PerfTrackerActionTypes.StartPerformanceTracking, { scenario: string }>
): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const performanceService = pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    yield effects.call(
        [performanceService, performanceService.startScenario],
        action.payload.scenario,
        false /* isPageInteractive */
    );
}
function* endTracking(
    action: ActionWithPayload<PerfTrackerActionTypes.StartPerformanceTracking, { scenario: string }>
): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const performanceService = pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    yield effects.call(
        [performanceService, performanceService.endScenario],
        PerfScenarios.Area,
        action.payload.scenario,
        false /* isPageInteractive */
    );
}
